import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";

@Component({
    selector: 'date-picker',
    templateUrl: 'date-picker.html'
})

export class DatePicker {

    public config: any;

    @Input() public date: string;
    @Input() public minDate: string;
    @Output() private dateChange = new EventEmitter();

    dateControl: Date;
    minDateControl: Date;

    constructor(public util: Util) {

        this.config = CONFIG;

    }

    ngOnInit() {

        if (!this.date) {
            this.dateControl = new Date();
        }
        else if (typeof this.date == 'string') {
            if (this.date.indexOf(' ') == -1) {
                this.date = this.date + ' 00:00:00';
            }
            this.dateControl = new Date(this.date);
        }

        if (!this.minDate) {
            this.minDateControl = new Date();
        }
        else if (typeof this.minDate == 'string') {
            if (this.minDate.indexOf(' ') == -1) {
                this.minDate = this.minDate + ' 00:00:00';
            }
            this.minDateControl = new Date(this.minDate);
        }

    }

    changed() {

        this.dateChange.emit(typeof this.date == 'string' ? this.util.strToData(this.dateControl.toLocaleDateString('pt-br')).split(' ')[0] : this.dateControl);

    }


}



// WEBPACK FOOTER //
// ./src/components/date-picker/date-picker.ts